import { render, staticRenderFns } from "./AccountLedgerMerchant.vue?vue&type=template&id=226b2e09"
import script from "./AccountLedgerMerchant.vue?vue&type=script&lang=js"
export * from "./AccountLedgerMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports